import * as yup from 'yup';

const nullableNumberField = () =>
  yup
    .number()
    .nullable()
    .transform((value, originalValue) => {
      if (
        originalValue === '' ||
        originalValue === null ||
        originalValue === undefined
      ) {
        return null;
      }
      return Number.isNaN(value) ? null : value;
    })
    .optional();

const productFields = {
  name: yup.string().required('Product name is required'),
  shortDescription: yup.string().required('Product description is required'),
  description: yup.string().optional(),
  price: yup
    .number()
    .required('Price is required')
    .min(0, 'Price must be at least 0'),
  costPrice: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value
    )
    .optional()
    .min(0, 'Cost Price must be at least 0'),
  discountedPrice: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value
    )
    .optional()
    .min(0, 'Discount must be at least 0'),
  quantity: yup.number().required('Stock Quantity is required'),
  variations: yup.string().optional(),
  colour: yup.string().optional(),
  size: yup.string().optional(),
  sku: yup.string().optional(),
  weight: yup.string().optional(),
  categoryId: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value
    )
    .required('Category is required'),
  subcategoryId: nullableNumberField(),
};

export const productCreationSchema = yup.object(productFields);

export const productUpdateSchema = yup.object({
  ...productFields,
  categoryId: nullableNumberField(),
  subcategoryId: nullableNumberField(),
});

export type ProductCreationFormData = yup.InferType<
  typeof productCreationSchema
>;

export type ProductUpdateFormData = yup.InferType<typeof productUpdateSchema>;
